import React from 'react'
import { Tag } from 'antd'
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  ExclamationCircleOutlined,
  WarningOutlined
} from '@ant-design/icons'
import { useTranslation } from 'react-i18next'

// 定義狀態設定 (Source of Truth)
// 參考 app/javascript/components/shared/orders/FulfillmentsPanel.jsx
const STATUS_CONFIG = {
  pending: { color: 'default', icon: <ClockCircleOutlined /> },
  allocated: { color: 'success', icon: <CheckCircleOutlined /> },
  partial_allocated: { color: 'warning', icon: <WarningOutlined /> },
  out_of_stock: { color: 'error', icon: <ExclamationCircleOutlined /> },
  processing: { color: 'processing', icon: <CheckCircleOutlined /> }, // Usually maps to picked/parcel
  picked: { color: 'processing', icon: <CheckCircleOutlined /> },     // Legacy/Frontend alias
  shipped: { color: 'success', icon: <CheckCircleOutlined /> },
  canceled: { color: 'default', icon: null },
  recorded: { color: 'default', icon: null },
}

const FulfillmentStatusLabel = ({ status }) => {
  const { t } = useTranslation()
  const config = STATUS_CONFIG[status] || { color: 'default', icon: null }

  return (
    <Tag color={config.color} icon={config.icon}>
      {t(`enums.fulfillment.status.${status}`, { defaultValue: status })}
    </Tag>
  )
}

export default FulfillmentStatusLabel
